module.exports = __webpack_public_path__ + "img/404.ff93b47f.png";